import React from "react";
import { Plus, Trash } from "@phosphor-icons/react";
import { DAY_NAMES, TIMES } from "./rules";

const inp = "rounded-sm border border-stone-300 bg-white px-2 py-1.5 text-sm";

const TimeSel = ({ value, onChange, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={inp} data-testid={testId}>
    {TIMES.map((t) => <option key={t} value={t}>{t}</option>)}
  </select>
);

const WeeklyHours = ({ rule, set }) => {
  const list = rule.weekly_hours || [];
  const upd = (i, patch) => set("weekly_hours", list.map((w, j) => (j === i ? { ...w, ...patch } : w)));
  return (
    <div className="mt-4 space-y-2" data-testid={`weekly-hours-${rule.slug}`}>
      <div className="text-xs uppercase tracking-[0.16em] text-ink-muted">Weekly hours</div>
      {DAY_NAMES.map((d, day) => (
        <div key={d} className={`flex flex-wrap items-center gap-2 ${rule.no_weekdays.includes(day) ? "opacity-50" : ""}`}>
          <span className="w-10 text-sm">{d}</span>
          {rule.no_weekdays.includes(day) && <span className="text-[11px] text-red-700">never works - ignored</span>}
          {list.map((w, i) => (w.day !== day ? null : (
            <span key={i} className="inline-flex items-center gap-1">
              <TimeSel value={w.from} onChange={(v) => upd(i, { from: v })} testId={`weekly-${rule.slug}-${day}-from-${i}`} />–
              <TimeSel value={w.until} onChange={(v) => upd(i, { until: v })} testId={`weekly-${rule.slug}-${day}-until-${i}`} />
              <button type="button" aria-label="Remove" onClick={() => set("weekly_hours", list.filter((_, j) => j !== i))}
                data-testid={`weekly-${rule.slug}-${day}-remove-${i}`} className="p-1 text-ink-muted hover:text-red-700"><Trash size={14} /></button>
            </span>
          )))}
          {!list.some((w) => w.day === day) && <span className="text-xs text-ink-muted/70">Closed</span>}
          <button type="button" onClick={() => set("weekly_hours", [...list, { day, from: "17:30", until: "20:00" }])}
            data-testid={`weekly-${rule.slug}-${day}-add`} className="inline-flex items-center gap-1 text-xs text-bronze-dark"><Plus size={12} /> hours</button>
        </div>
      ))}
    </div>
  );
};

export const UsualHours = ({ rule, set }) => {
  const t = rule.slug;
  const toggleDay = (d) => set("no_weekdays", rule.no_weekdays.includes(d) ? rule.no_weekdays.filter((x) => x !== d) : [...rule.no_weekdays, d]);
  return (
    <details open className="p-5 bg-white border border-stone-200/60 rounded-md" data-testid={`usual-hours-${t}`}>
      <summary className="cursor-pointer font-serif text-xl">Usual weekly hours</summary>
      <p className="text-xs text-ink-muted mt-2">Green days use these weekly hours (UK time), up to the date below. Closed dates always win, and extra hours add to them.</p>
      <label className="mt-4 flex flex-wrap items-center gap-2 text-sm">
        <input type="checkbox" checked={!!rule.usual_hours_until} data-testid={`usual-toggle-${t}`}
          onChange={(e) => set("usual_hours_until", e.target.checked ? new Date(Date.now() + 90 * 864e5).toISOString().slice(0, 10) : null)} />
        Open in usual hours until
        {rule.usual_hours_until && <input type="date" value={rule.usual_hours_until} onChange={(e) => set("usual_hours_until", e.target.value)} className={inp} data-testid={`usual-until-${t}`} />}
      </label>
      <WeeklyHours rule={rule} set={set} />
      <div className="mt-4 text-xs uppercase tracking-[0.16em] text-ink-muted">Never works on</div>
      <div className="mt-2 flex flex-wrap gap-2">
        {DAY_NAMES.map((d, i) => (
          <label key={d} className={`px-3 py-1.5 rounded-full border text-sm cursor-pointer ${rule.no_weekdays.includes(i) ? "bg-red-50 border-red-300 text-red-800" : "border-stone-300"}`}>
            <input type="checkbox" className="sr-only" checked={rule.no_weekdays.includes(i)} onChange={() => toggleDay(i)} data-testid={`weekday-${t}-${i}`} />{d}
          </label>
        ))}
      </div>
    </details>
  );
};
